import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { IsBoolean } from "class-validator"

/**
 * Radix radio groups stringify values. Only an explicit Yes (`true` / `"true"`)
 * should enable a conditional onboarding manager.
 */
export function isOnboardingRequirementEnabled(value: unknown): boolean {
  return value === true || value === "true"
}

@Serializable
export class OnboardingRequirementModel {
  @IsBoolean({
    message: "common:form.errors.empty",
    groups: ["rfs"],
  })
  laptop: boolean = true
  @IsBoolean({
    message: "common:form.errors.empty",
    groups: ["rfs"],
  })
  timeRegistrationAccess: boolean = true
  @IsBoolean({
    message: "common:form.errors.empty",
    groups: ["rfs"],
  })
  activeDirectoryAccess: boolean = true

  @IsBoolean({
    message: "common:form.errors.empty",
    groups: ["access_card"],
  })
  accessCard: boolean = false

  constructor(init?: Partial<OnboardingRequirementModel>) {
    Object.assign(this, init)
  }
}
